var map = {
	"./acod.jpg": 62,
	"./acod_currency.jpg": 63,
	"./anno.jpg": 64,
	"./discover.png": 65,
	"./fc5.jpg": 66,
	"./guide-background.png": 67,
	"./guide_games.png": 68,
	"./icon-upc.png": 69,
	"./icon-web.png": 70,
	"./rewards.png": 71,
	"./tctd2.jpg": 72,
	"./trials.jpg": 73,
	"./watch_dogs.jpg": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;